import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '../services/api.js'
import { usePageTitle } from '../hooks/usePageTitle.js'

export default function ResetPasswordPage() {
  usePageTitle('Set new password')
  const [searchParams]        = useSearchParams()
  const token                 = searchParams.get('token')
  const navigate              = useNavigate()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm]   = useState('')
  const [done, setDone]         = useState(false)
  const [loading, setLoading]   = useState(false)
  const [error, setError]       = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    if (password !== confirm) {
      setError('Passwords do not match'); return
    }
    setLoading(true); setError(null)
    try {
      await api.post('/auth/reset-password', { token, password })
      setDone(true)
      setTimeout(() => navigate('/login'), 2500)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <span className="auth-logo">Genealogic</span>
          <div className="auth-notice">
            <p>Invalid reset link. Please request a new one.</p>
            <Link to="/forgot-password" className="btn btn-gold" style={{ marginTop: '1rem', display: 'block', textAlign: 'center' }}>
              Request reset link
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <span className="auth-logo">Genealogic</span>
        <p className="auth-tagline">Choose a new password</p>

        {done ? (
          <div className="auth-notice">
            <p>Password updated. Redirecting you to sign in…</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label>
              New password
              <input
                type="password"
                value={password}
                placeholder="At least 8 characters"
                onChange={e => setPassword(e.target.value)}
                minLength={8}
                required
                autoFocus
              />
            </label>
            <label>
              Confirm password
              <input
                type="password"
                value={confirm}
                placeholder="Repeat your new password"
                onChange={e => setConfirm(e.target.value)}
                required
              />
            </label>
            {error && <p className="error">{error}</p>}
            <button type="submit" className="btn btn-gold" disabled={loading}>
              {loading ? 'Saving…' : 'Set new password'}
            </button>
          </form>
        )}

        {!done && (
          <p className="auth-switch">
            <Link to="/login">Back to sign in</Link>
          </p>
        )}
      </div>
      <a href="https://genealogic.ai" className="auth-back">← Back to genealogic.ai</a>
    </div>
  )
}
